var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecruitment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2068 27.3135H20.3613V31.5921H18.2068V27.3135Z",
    fill: "#FFCC66"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.65
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3613 27.4834V28.4937C20.0144 28.5972 19.6553 28.658 19.2841 28.658C18.9128 28.658 18.5537 28.5972 18.2068 28.4937V27.4834H20.3613Z",
    fill: "#CEC5AE"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6573 23.7417C14.6573 26.417 16.8263 28.5878 19.5035 28.5878C22.1806 28.5878 24.3496 26.417 24.3496 23.7417C24.3496 21.0663 22.1806 18.8955 19.5035 18.8955C16.8263 18.8955 14.6573 21.0663 14.6573 23.7417Z",
    fill: "#F48000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.178 37.2281V29.243L17.6106 29.1152L19.3269 30.7646L20.6659 29.1152L24.3906 29.243V37.2281H14.178Z",
    fill: "#F48000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6458 31.6342C11.8163 30.3256 12.8509 29.2788 14.1595 29.1327C14.1595 29.1327 14.1716 29.1327 14.1777 29.1327L17.1965 29.1084L19.3266 36.4971L21.1282 29.1084L24.3904 29.1327C24.3904 29.1327 24.4025 29.1327 24.4086 29.1327C25.7172 29.2788 26.7518 30.3256 26.9222 31.6342L27.6465 37.2274H24.6034L24.3904 35.785V37.2274H14.1777V35.785L13.9647 37.2274H10.9216L11.6458 31.6342Z",
    fill: "#FFE4C6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3184 24.6777C37.3184 34.5495 29.315 42.5468 19.4493 42.5468C9.58351 42.5468 1.58015 34.5434 1.58015 24.6777C1.58015 14.812 9.58351 6.80859 19.4493 6.80859C29.315 6.80859 37.3184 14.812 37.3184 24.6777ZM31.5852 24.6777C31.5852 17.9768 26.1502 12.5418 19.4493 12.5418C12.7483 12.5418 7.31336 17.9768 7.31336 24.6777C7.31336 31.3786 12.7483 36.8136 19.4493 36.8136C26.1502 36.8136 31.5852 31.3786 31.5852 24.6777Z",
    fill: "#F48000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5617 48.439L28.9385 35.5667L32.8093 30.8682L48.4387 43.7405C49.7229 44.7995 49.9054 46.6984 48.8464 47.9826L48.8099 48.0313C47.7509 49.3155 45.852 49.498 44.5678 48.439H44.5617Z",
    fill: "#F48000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitment);
export default __webpack_public_path__ + "static/media/Recruitment.0112620fbeb13b960e033cbcf98c4bb2.svg";
export { ForwardRef as ReactComponent };